import { NgModule, ModuleWithProviders } from '@angular/core';
import { AuthService } from './auth.service';
import { DriverService } from './driver.service';
import { LoaderService } from './loader.service';



@NgModule({

})
export class FactoryModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: FactoryModule,
      providers: [AuthService, DriverService, LoaderService]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/factory.service.ts